import React from 'react';

const CardsContent = ({ data }) => {
    return (
        <>
            <section className={'text-[#4F4F4F] mt-[-25px]'}>

                <article className={'flex flex-row items-center justify-center w-full py-13 bg-[#FAFAFA] print:bg-white! border border-[#E5E7EB] border-r-0 border-l-0'}>
                    <div className="flex flex-col items-center justify-center w-[50%]">
                        <span className={'text-[30px] font-thin'}>Passagens de entrada</span>
                        <span className={'text-[45px] font-bold'}>{data?.entrance_passages ?? "0"}</span>
                    </div>

                    <div className="flex flex-col items-center justify-center w-[50%]">
                        <span className={'text-[30px] font-thin'}>Passagens de saída</span>
                        <span className={'text-[45px] font-bold'}>{data?.exit_passages ?? "0"}</span>
                    </div>
                </article>


                <article className={'flex flex-row items-center justify-center w-full py-13 border border-[#E5E7EB] border-r-0 border-l-0 border-t-0'}>
                    <div className="flex flex-col items-center justify-center w-[50%]">
                        <span className={'text-[30px] font-thin'}>Passagens internas</span>
                        <span className={'text-[45px] font-bold'}>{data?.internal_passages ?? "0"}</span>
                    </div>

                    <div className="flex flex-col items-center justify-center w-[50%]">
                        <span className={'text-[30px] font-thin'}>Total de passagens</span>
                        <span className={'text-[45px] font-bold'}>{data?.total_passages ?? "0"}</span>
                    </div>
                </article>

            </section>
        </>
    );
};

export default CardsContent;